export default function(deg){

    return deg * Math.PI / 180;
}